export default "__VITE_ASSET__1VRkBpmw__"